import React from 'react';
import CardDetail from '../components/Card/CardDetail';
import CardWisata from '../components/Card/CardWisata';
import Navbar from '../components/Navbar';
import Reviews from '../components/Reviews';
import Footer from '../components/Footer';
import ListWisata from '../components/List/ListWisata';

export default function DetailWisata() {
  return (
    <div>
      {/* <div className="relative">
        <img src="/assets/images/image-wisata.png" alt="image-wisata" />
        <div className="absolute top-0 right-[10%]">
          <Navbar />
        </div>
      </div> */}
      <div>
        <div className="container mx-auto px-8">
          <Navbar />
        </div>
        <img
          src="/assets/images/image-wisata.png"
          alt="image-wisata"
          className="md:-mt-[200px] md:h-auto mt-0 h-[464px]"
        />
      </div>

      <div className="container mx-auto px-8">
        <div className="-mt-[40px] flex md:flex-row flex-col mb-24">
          <div className="md:w-2/3 w-full mr-8">
            <CardWisata />
          </div>
          <div className="md:w-1/3 w-full md:mt-0 mt-5 h-max">
            <CardDetail />
          </div>
        </div>
        <Reviews />
        {/* <ListWisata /> */}
      </div>
      <Footer />
    </div>
  );
}
